import {embeddedCheckoutSvg as Icon__small__embeddedCheckoutSvg} from '../Icon__small/Icon__small--embeddedCheckout.js';
import {embeddedCheckoutSvg as Icon__xsmall__embeddedCheckoutSvg} from '../Icon__xsmall/Icon__xsmall--embeddedCheckout.js';

export var embeddedCheckout = {
  name: 'embeddedCheckout',
  category: 'icon',
  colorable: true,
  svg: Icon__small__embeddedCheckoutSvg,
  alt: {
    Icon__small: Icon__small__embeddedCheckoutSvg,
    Icon__xsmall: Icon__xsmall__embeddedCheckoutSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
